export type BuiltMenuLeaf = {
  key: string;
  path: string;
  labelKey: string;
  /** 必填权限：空数组表示已登录且已通过 MFA 即可；`"*"` 表超级管理员直通 */
  requiredPermissions: readonly string[];
};

export type BuiltMenuNode = BuiltMenuLeaf | BuiltMenuFolder;

export type BuiltMenuFolder = {
  key: string;
  labelKey: string;
  /** 顶层聚合：只要任意子项有权即展示文件夹 */
  children: BuiltMenuLeaf[];
};

function leaf(
  key: string,
  path: string,
  labelKey: string,
  requiredPermissions: readonly string[] = []
): BuiltMenuLeaf {
  return { key, path, labelKey, requiredPermissions };
}

/**
 * 侧栏 IA（见 `doc/admin/设计文档.md` §2）；权限串需与后端 `permissions` 对齐，新增模块时先看 OpenAPI RBAC。
 */
export const MENU_TREE: BuiltMenuNode[] = [
  leaf("dashboard", "/dashboard", "menu.dashboard", []),
  leaf("users", "/users", "menu.users", ["users:read"]),
  leaf("audit", "/audit-logs", "menu.audit", ["audit:read"]),
  leaf("vpn-monitoring", "/vpn/monitoring", "menu.vpnMonitoring", []),
  {
    key: "vpn",
    labelKey: "menu.vpnGroup",
    children: [
      leaf("vpn-protocols", "/vpn/protocols", "menu.vpnProtocols", ["*"]),
      leaf("vpn-profiles", "/vpn/profiles", "menu.vpnProfiles", ["*"]),
      leaf("vpn-nodes", "/vpn/nodes", "menu.vpnNodes", ["*"]),
    ],
  },
  leaf("operators", "/operators", "menu.operators", ["*"]),
  {
    key: "more",
    labelKey: "menu.morePlaceholder",
    children: [
      leaf("channels", "/channels", "menu.channels", ["*"]),
      leaf("releases", "/releases", "menu.releases", ["*"]),
    ],
  },
];

/** 扁平化路径 → 路由守卫用 */
export function routeRequiredPermissions(pathname: string): readonly string[] {
  const flattened: BuiltMenuLeaf[] = [];
  for (const n of MENU_TREE) {
    if ("path" in n) flattened.push(n);
    else n.children.forEach((c) => flattened.push(c));
  }
  const exact = flattened.find((l) => l.path === pathname);
  if (exact) return exact.requiredPermissions;
  if (pathname.startsWith("/users/") && pathname !== "/users")
    return ["users:read"];
  return ["*"];
}

export function flattenMenuLeaves(): BuiltMenuLeaf[] {
  const out: BuiltMenuLeaf[] = [];
  for (const n of MENU_TREE) {
    if ("path" in n) out.push(n);
    else out.push(...n.children);
  }
  return out;
}
